var map = {
	"./custom.css": "1a36",
	"./theme_gold/css/accordion.css": "5416",
	"./theme_gold/css/authen.css": "2198",
	"./theme_gold/css/bank-card.css": "e9b4",
	"./theme_gold/css/campaign/campaign_reset.css": "e024",
	"./theme_gold/css/campaign/general.css": "20d6",
	"./theme_gold/css/campaign/style_special_deposit.css": "f2c2",
	"./theme_gold/css/championship.css": "e9a9",
	"./theme_gold/css/common_asset.css": "1790",
	"./theme_gold/css/dailyAttend/event-bonus.css": "a90f",
	"./theme_gold/css/footer.css": "8b20",
	"./theme_gold/css/landing-page.css": "6ecb",
	"./theme_gold/css/main.css": "fcb4",
	"./theme_gold/css/my-mall.css": "a3ee",
	"./theme_gold/css/my_kyc.css": "6213",
	"./theme_gold/css/popup.css": "a5e2",
	"./theme_gold/css/reset.css": "ae06",
	"./theme_gold/css/style.css": "61e3",
	"./theme_gold/css/useful_link.css": "b6f9",
	"./theme_gold/css/vip.css": "1459",
	"./theme_gold/images/9_gift.png": "c68c",
	"./theme_gold/images/Angle-left-g.png": "7294",
	"./theme_gold/images/Angle-left.png": "407c",
	"./theme_gold/images/Angle-right-g.png": "6363",
	"./theme_gold/images/Angle-right.png": "7040",
	"./theme_gold/images/BarbarianFury.png": "92a6",
	"./theme_gold/images/BattleDwarfXmas.png": "23b7",
	"./theme_gold/images/BoatBonanzaDownUnder.png": "9d98",
	"./theme_gold/images/DragonKingHotPots.png": "b099",
	"./theme_gold/images/Ellipse.png": "efd7",
	"./theme_gold/images/H5_TOP.jpg": "4ac0",
	"./theme_gold/images/HawaiianDreamXmas.png": "e196",
	"./theme_gold/images/LogoLoading_circle01.png": "8fe7",
	"./theme_gold/images/LogoLoading_circle02.png": "0b79",
	"./theme_gold/images/LogoLoading_katsu.png": "bf62",
	"./theme_gold/images/OiranDreamXmas.png": "6549",
	"./theme_gold/images/PyramidRisingx33.png": "1739",
	"./theme_gold/images/RichWildeandtheTomeofInsanity.png": "f06a",
	"./theme_gold/images/SparkofGenius.png": "0cc0",
	"./theme_gold/images/Starstruck.png": "7f34",
	"./theme_gold/images/TheGoldenOwlofAthena.png": "030e",
	"./theme_gold/images/TheSwordandtheGrailExcalibur.png": "bbeb",
	"./theme_gold/images/Withdraw-gold.svg": "171d",
	"./theme_gold/images/Withdraw-icon.svg": "4d29",
	"./theme_gold/images/about_bg04.png": "0ae5",
	"./theme_gold/images/add.svg": "00f8",
	"./theme_gold/images/affiliates.png": "027e",
	"./theme_gold/images/bankB-gold.svg": "a442",
	"./theme_gold/images/bankB-icon.svg": "1023",
	"./theme_gold/images/bg-masthead-mb.png": "3128",
	"./theme_gold/images/bg-masthead.png": "45df",
	"./theme_gold/images/bg_brush.png": "ad51",
	"./theme_gold/images/bg_repeat.png": "a63dc",
	"./theme_gold/images/bg_top.png": "7453",
	"./theme_gold/images/bitcoin-btc-gold.svg": "2ece",
	"./theme_gold/images/bitcoin-btc-logo.svg": "e7ed",
	"./theme_gold/images/blog.png": "bb49",
	"./theme_gold/images/bullhorn.svg": "1497",
	"./theme_gold/images/cach-gold.svg": "3d0e",
	"./theme_gold/images/cach-icon.svg": "70a4",
	"./theme_gold/images/card-gold.svg": "7597",
	"./theme_gold/images/card-icon.svg": "a316",
	"./theme_gold/images/ch_logo.png": "1f60",
	"./theme_gold/images/championship-bg.jpg": "6480",
	"./theme_gold/images/championship-main-event-bg.jpg": "0c0c",
	"./theme_gold/images/check-on.png": "aac5",
	"./theme_gold/images/collect.png": "987c",
	"./theme_gold/images/collect_full.png": "14c4",
	"./theme_gold/images/comments-question.svg": "a918",
	"./theme_gold/images/completed.png": "a921",
	"./theme_gold/images/creditcard-back.png": "f6ab",
	"./theme_gold/images/creditcard-front.png": "78c8",
	"./theme_gold/images/crypto-ada.svg": "f014",
	"./theme_gold/images/crypto-bnb.svg": "ea95",
	"./theme_gold/images/crypto-btc.svg": "8555",
	"./theme_gold/images/crypto-dai.svg": "f1cc",
	"./theme_gold/images/crypto-doge.svg": "a829",
	"./theme_gold/images/crypto-eos.svg": "3f53",
	"./theme_gold/images/crypto-eth.svg": "0ecc",
	"./theme_gold/images/crypto-shib.svg": "9d9c",
	"./theme_gold/images/crypto-trx.svg": "8e2c",
	"./theme_gold/images/crypto-usdc.svg": "a711",
	"./theme_gold/images/crypto-usdt.svg": "6fb5",
	"./theme_gold/images/daily-attend.png": "d3ab",
	"./theme_gold/images/db_gift_left.png": "d01c",
	"./theme_gold/images/db_gift_right.png": "5744",
	"./theme_gold/images/db_hero_img_mb.png": "c127",
	"./theme_gold/images/db_hero_img_pc.png": "104d",
	"./theme_gold/images/db_icon_coin.png": "5b5c",
	"./theme_gold/images/db_icon_lock.png": "4e5e",
	"./theme_gold/images/deposit-gold.svg": "60aa",
	"./theme_gold/images/deposit-icon.svg": "3c1b",
	"./theme_gold/images/dot-dk.svg": "94d4",
	"./theme_gold/images/dot-orange.svg": "ada5",
	"./theme_gold/images/dot.svg": "4f38",
	"./theme_gold/images/dw.png": "c1d3",
	"./theme_gold/images/electron-gold.svg": "f8a1",
	"./theme_gold/images/electron-icon.svg": "082a",
	"./theme_gold/images/email.svg": "b4d8",
	"./theme_gold/images/en_logo.png": "4d1a",
	"./theme_gold/images/event.png": "d8d7",
	"./theme_gold/images/event_specail_deposit_bg3.png": "462e",
	"./theme_gold/images/favorite.png": "f533",
	"./theme_gold/images/footer_gaming1.png": "2398",
	"./theme_gold/images/footer_gaming2.png": "8058",
	"./theme_gold/images/footer_gaming3.png": "890e",
	"./theme_gold/images/footer_gaming4.png": "18b2",
	"./theme_gold/images/fortunewheel.png": "c281",
	"./theme_gold/images/friend_promo.png": "f7ff",
	"./theme_gold/images/giftbox.png": "4db4",
	"./theme_gold/images/headset.png": "550d",
	"./theme_gold/images/heart-line.svg": "343e",
	"./theme_gold/images/heart.svg": "5fe9",
	"./theme_gold/images/history.png": "89d8",
	"./theme_gold/images/home-arrow-left.png": "914e",
	"./theme_gold/images/home-arrow-right.png": "4bb9",
	"./theme_gold/images/icon-account.png": "1dc5",
	"./theme_gold/images/icon-add.png": "dab3",
	"./theme_gold/images/icon-alert-kyc.png": "d9bc",
	"./theme_gold/images/icon-alert.png": "bc92",
	"./theme_gold/images/icon-arrow-down-2.png": "3e9b",
	"./theme_gold/images/icon-arrow-down-3.png": "a110",
	"./theme_gold/images/icon-arrow-down-4-disabled.png": "8a77",
	"./theme_gold/images/icon-arrow-down-4.png": "7b08",
	"./theme_gold/images/icon-arrow-down-gold.png": "ab44",
	"./theme_gold/images/icon-arrow-down.png": "b346",
	"./theme_gold/images/icon-arrow-dropdown.png": "d851",
	"./theme_gold/images/icon-arrow-right.png": "28fb",
	"./theme_gold/images/icon-check-black.png": "bf96",
	"./theme_gold/images/icon-check.png": "cac4",
	"./theme_gold/images/icon-checked.png": "b407",
	"./theme_gold/images/icon-close-black.png": "ed52",
	"./theme_gold/images/icon-close.png": "4297",
	"./theme_gold/images/icon-close_index_phone.png": "b998",
	"./theme_gold/images/icon-coin.png": "2879",
	"./theme_gold/images/icon-copy-2.png": "9df4",
	"./theme_gold/images/icon-copy.png": "96f0",
	"./theme_gold/images/icon-credit.png": "93c0",
	"./theme_gold/images/icon-crown.png": "6cb3",
	"./theme_gold/images/icon-date.png": "1e05",
	"./theme_gold/images/icon-detail.png": "61c1",
	"./theme_gold/images/icon-diamond.png": "8292",
	"./theme_gold/images/icon-download.png": "5225",
	"./theme_gold/images/icon-edit-dark.png": "2296",
	"./theme_gold/images/icon-edit-fill.png": "5f84",
	"./theme_gold/images/icon-expand-w.png": "d1e6",
	"./theme_gold/images/icon-favorite-active.png": "6a1d",
	"./theme_gold/images/icon-favorite.png": "afeb",
	"./theme_gold/images/icon-filter.png": "b706",
	"./theme_gold/images/icon-flag.png": "3935",
	"./theme_gold/images/icon-game-search.png": "0bec",
	"./theme_gold/images/icon-home.png": "7304",
	"./theme_gold/images/icon-info.png": "13d5",
	"./theme_gold/images/icon-invite-bonus.png": "8015",
	"./theme_gold/images/icon-invite-promo.png": "aeda",
	"./theme_gold/images/icon-invite-weekly.png": "e0d4",
	"./theme_gold/images/icon-kyc-add.png": "814a",
	"./theme_gold/images/icon-kyc-close.png": "3f94",
	"./theme_gold/images/icon-kyc-open.png": "f957",
	"./theme_gold/images/icon-lock.png": "c9ed",
	"./theme_gold/images/icon-member-active.png": "5ee8",
	"./theme_gold/images/icon-member.png": "a63d",
	"./theme_gold/images/icon-nav-home.png": "0544",
	"./theme_gold/images/icon-news-w.png": "1d7b",
	"./theme_gold/images/icon-notice.png": "3323",
	"./theme_gold/images/icon-password.png": "5876",
	"./theme_gold/images/icon-phone-active.png": "3b9d",
	"./theme_gold/images/icon-phone.png": "c6fe",
	"./theme_gold/images/icon-qrcode.png": "b3df",
	"./theme_gold/images/icon-real-name.png": "bc12",
	"./theme_gold/images/icon-recommend.png": "01f3",
	"./theme_gold/images/icon-refresh.png": "6426",
	"./theme_gold/images/icon-register-success.png": "b335",
	"./theme_gold/images/icon-search.png": "735c",
	"./theme_gold/images/icon-slot-select.png": "d9bcc",
	"./theme_gold/images/icon-slot.png": "9e01",
	"./theme_gold/images/icon-top-arrow.svg": "f7c8",
	"./theme_gold/images/icon-usdt.png": "8ff3",
	"./theme_gold/images/icon_alert.png": "60a2",
	"./theme_gold/images/icon_allgames.png": "7079",
	"./theme_gold/images/icon_awesome_bitcoin.png": "bdb6",
	"./theme_gold/images/icon_bell.png": "9dd8",
	"./theme_gold/images/icon_calendar_light.png": "e6bd",
	"./theme_gold/images/icon_card_light.png": "980f",
	"./theme_gold/images/icon_check_white.png": "ac67",
	"./theme_gold/images/icon_close.png": "7374",
	"./theme_gold/images/icon_copy_white.png": "428d",
	"./theme_gold/images/icon_download_white.png": "3ec2",
	"./theme_gold/images/icon_email.png": "becd",
	"./theme_gold/images/icon_ig.png": "d816",
	"./theme_gold/images/icon_img_01.png": "f154",
	"./theme_gold/images/icon_img_03.png": "0f71",
	"./theme_gold/images/icon_img_04.png": "ab60",
	"./theme_gold/images/icon_img_05.png": "cbeb",
	"./theme_gold/images/icon_img_06.png": "ecc1",
	"./theme_gold/images/icon_img_07.png": "74cc",
	"./theme_gold/images/icon_img_08.png": "abc5",
	"./theme_gold/images/icon_img_09.png": "93e2",
	"./theme_gold/images/icon_img_10.png": "620a",
	"./theme_gold/images/icon_img_11.png": "b86d",
	"./theme_gold/images/icon_img_12.png": "d245",
	"./theme_gold/images/icon_img_13.png": "aebc",
	"./theme_gold/images/icon_img_14.png": "c0f5",
	"./theme_gold/images/icon_img_15.png": "384f",
	"./theme_gold/images/icon_japan.png": "40fc",
	"./theme_gold/images/icon_lock_light.png": "8422",
	"./theme_gold/images/icon_metro_credit_card.png": "1727",
	"./theme_gold/images/icon_payment_bankomat.png": "ca5d",
	"./theme_gold/images/icon_promo_check.png": "1ee0",
	"./theme_gold/images/icon_promo_check_v2.png": "7b00",
	"./theme_gold/images/icon_shield_gray.png": "c7ef",
	"./theme_gold/images/icon_simple_electron.png": "00ec",
	"./theme_gold/images/icon_tab_favorite.png": "20a5",
	"./theme_gold/images/icon_tag_hot.png": "ac63",
	"./theme_gold/images/icon_tag_new.png": "0dde",
	"./theme_gold/images/icon_tag_noBonus.png": "f329",
	"./theme_gold/images/icon_trash.png": "9471",
	"./theme_gold/images/icon_twitter.png": "fe57",
	"./theme_gold/images/icon_user_light.png": "e0f6",
	"./theme_gold/images/icon_youtube.png": "a7a4",
	"./theme_gold/images/image-bank.png": "3fdc",
	"./theme_gold/images/image-upload.png": "efe2",
	"./theme_gold/images/instruction.png": "2a26",
	"./theme_gold/images/iocn-trash-fill.png": "cb4a",
	"./theme_gold/images/japan.png": "3686",
	"./theme_gold/images/jp-yen.svg": "19ca",
	"./theme_gold/images/jp_logo.png": "930c",
	"./theme_gold/images/leave.png": "3876",
	"./theme_gold/images/lights_m.png": "bcac",
	"./theme_gold/images/live.png": "cf51",
	"./theme_gold/images/login-left-2.jpg": "95f1",
	"./theme_gold/images/login-left.jpg": "5ea3",
	"./theme_gold/images/login-left.png": "f4e9",
	"./theme_gold/images/login-logo-2-mb.jpg": "6628",
	"./theme_gold/images/login-logo.jpg": "caca",
	"./theme_gold/images/logo-2.webp": "25a0",
	"./theme_gold/images/logo.png": "bbcd",
	"./theme_gold/images/logo_ft.png": "d16c",
	"./theme_gold/images/logo_katsuwin.png": "c293",
	"./theme_gold/images/lpfv-pc-2000.png": "73b4",
	"./theme_gold/images/lpfv-pc-3000.png": "b437",
	"./theme_gold/images/lpfv-pc-4000.png": "6ed0",
	"./theme_gold/images/lpfv-pc-5000.png": "2f2f",
	"./theme_gold/images/lpfv-pc.png": "2e36",
	"./theme_gold/images/lpfv-sp-2000.png": "8a83",
	"./theme_gold/images/lpfv-sp-3000.png": "5a9e",
	"./theme_gold/images/lpfv-sp-4000.png": "9de3",
	"./theme_gold/images/lpfv-sp-5000.png": "b1db",
	"./theme_gold/images/lpfv-sp.png": "040e",
	"./theme_gold/images/main_bg.jpg": "9deb",
	"./theme_gold/images/mall-invite-image.png": "26be",
	"./theme_gold/images/mall-product-image.png": "d8be",
	"./theme_gold/images/money_pop.png": "b7b7",
	"./theme_gold/images/monyback-gold.svg": "63c5",
	"./theme_gold/images/monyback-icon.svg": "1513",
	"./theme_gold/images/my-account.png": "88ef",
	"./theme_gold/images/my_kyc_ex1.png": "c235",
	"./theme_gold/images/my_kyc_ex2.webp": "aa91",
	"./theme_gold/images/nav-bottom-deposit-active.png": "5a42",
	"./theme_gold/images/nav-bottom-deposit.png": "bc5a",
	"./theme_gold/images/nav-bottom-game-active.png": "7561",
	"./theme_gold/images/nav-bottom-game.png": "3824",
	"./theme_gold/images/nav-bottom-home-active.png": "d640",
	"./theme_gold/images/nav-bottom-home-mobile-index.png": "fb75",
	"./theme_gold/images/nav-bottom-home.png": "65e1",
	"./theme_gold/images/nav-bottom-my-active.png": "65c9",
	"./theme_gold/images/nav-bottom-my.png": "c4fe",
	"./theme_gold/images/nav-bottom-offers-active.png": "3854",
	"./theme_gold/images/nav-bottom-offers.png": "47f5",
	"./theme_gold/images/nav-bottom-toggle.png": "c337",
	"./theme_gold/images/new_guide.png": "32ff",
	"./theme_gold/images/no-data.png": "9c8b",
	"./theme_gold/images/no.svg": "ef64",
	"./theme_gold/images/oncasy_logo.png": "55c9",
	"./theme_gold/images/pachislot.png": "54a9",
	"./theme_gold/images/program.png": "f10a",
	"./theme_gold/images/rank-1st.png": "05eb",
	"./theme_gold/images/rank-2nd.png": "8429",
	"./theme_gold/images/rank-3rd.png": "0128",
	"./theme_gold/images/register-bg.jpg": "dc80",
	"./theme_gold/images/register-logo-pc.jpg": "9db7",
	"./theme_gold/images/register-logo.jpg": "48f5",
	"./theme_gold/images/register-logo.png": "569a",
	"./theme_gold/images/registration-2000.png": "631e",
	"./theme_gold/images/registration-3000.png": "7728",
	"./theme_gold/images/registration-4000.png": "7530",
	"./theme_gold/images/registration-5000.png": "4f3e",
	"./theme_gold/images/registration.png": "7840",
	"./theme_gold/images/shop.png": "b51c",
	"./theme_gold/images/skill.png": "065d",
	"./theme_gold/images/slots.png": "da60",
	"./theme_gold/images/spin_wheel_bg_lt.png": "9952",
	"./theme_gold/images/spin_wheel_bg_rt.png": "cd50",
	"./theme_gold/images/stake-logo.png": "039f",
	"./theme_gold/images/structure01.png": "9d7b",
	"./theme_gold/images/structure01.svg": "e843",
	"./theme_gold/images/structure02.png": "ac4c",
	"./theme_gold/images/structure02.svg": "ccfc",
	"./theme_gold/images/structure03.png": "ad6a",
	"./theme_gold/images/structure03.svg": "767f",
	"./theme_gold/images/sup/account_mb_01.jpg": "6b10",
	"./theme_gold/images/sup/account_mb_02.jpg": "6492",
	"./theme_gold/images/sup/account_mb_03.jpg": "9d3f",
	"./theme_gold/images/sup/account_mb_03.png": "1f73",
	"./theme_gold/images/sup/account_mb_04.jpg": "04fb",
	"./theme_gold/images/sup/account_mb_05.jpg": "693d",
	"./theme_gold/images/sup/account_pc_01.png": "8452",
	"./theme_gold/images/sup/account_pc_02.png": "a174",
	"./theme_gold/images/sup/account_pc_03.png": "4e7a",
	"./theme_gold/images/sup/account_pc_04.webp": "050f",
	"./theme_gold/images/sup/account_pc_05.png": "b1b8",
	"./theme_gold/images/sup/account_pc_06.png": "0f15",
	"./theme_gold/images/sup/account_pc_07.png": "dd3a",
	"./theme_gold/images/sup/account_pc_08.png": "1e33",
	"./theme_gold/images/sup/binding_mb_tab_01.png": "7300",
	"./theme_gold/images/sup/binding_mb_tab_02.png": "5f89",
	"./theme_gold/images/sup/binding_mb_tab_03.png": "3846",
	"./theme_gold/images/sup/binding_mb_tab_04.png": "3c2d",
	"./theme_gold/images/sup/binding_mb_tab_05.png": "c0c5",
	"./theme_gold/images/sup/binding_mb_tab_06.png": "e364",
	"./theme_gold/images/sup/binding_pc_tab_01.png": "5e35",
	"./theme_gold/images/sup/binding_pc_tab_02.png": "b9f3",
	"./theme_gold/images/sup/binding_pc_tab_03.png": "cc8c",
	"./theme_gold/images/sup/binding_pc_tab_04.png": "a632",
	"./theme_gold/images/sup/binding_pc_tab_05.png": "9799",
	"./theme_gold/images/sup/binding_pc_tab_06.png": "7be0",
	"./theme_gold/images/sup/confirmID_2-2.webp": "e8d4",
	"./theme_gold/images/sup/coupon_mb_tab_01.png": "9d4a",
	"./theme_gold/images/sup/coupon_mb_tab_02.png": "7111",
	"./theme_gold/images/sup/coupon_pc_tab_01.png": "e605",
	"./theme_gold/images/sup/coupon_pc_tab_02.png": "ec74",
	"./theme_gold/images/sup/event_mb_tab_01.png": "35d2",
	"./theme_gold/images/sup/event_mb_tab_02.png": "a656",
	"./theme_gold/images/sup/event_mb_tab_03.png": "9b42",
	"./theme_gold/images/sup/event_pc_tab_01.png": "466d",
	"./theme_gold/images/sup/event_pc_tab_02.png": "7ded",
	"./theme_gold/images/sup/event_pc_tab_03.png": "6e85",
	"./theme_gold/images/sup/login_tab01_01.png": "4c3c",
	"./theme_gold/images/sup/login_tab01_02.png": "4e58",
	"./theme_gold/images/sup/login_tab01_03.png": "3baf",
	"./theme_gold/images/sup/login_tab01_04.png": "84c7",
	"./theme_gold/images/sup/login_tab01_05.png": "0828",
	"./theme_gold/images/sup/login_tab02_02.png": "fcf8",
	"./theme_gold/images/sup/login_tab02_03.png": "2a37",
	"./theme_gold/images/sup/login_tab02_04.png": "f922",
	"./theme_gold/images/sup/login_tab02_05.png": "7219",
	"./theme_gold/images/sup/login_tab03_01.png": "162e",
	"./theme_gold/images/sup/login_tab03_02.png": "a51c",
	"./theme_gold/images/sup/login_tab03_03.png": "7b3c",
	"./theme_gold/images/sup/login_tab03_04.png": "fe16",
	"./theme_gold/images/sup/login_tab03_05.png": "6142",
	"./theme_gold/images/sup/login_tab04_02.png": "3107",
	"./theme_gold/images/sup/login_tab04_03.png": "0b7b",
	"./theme_gold/images/sup/login_tab04_04.png": "43d2",
	"./theme_gold/images/sup/login_tab04_05.png": "97b5",
	"./theme_gold/images/sup/payment_mb_01.png": "82ad",
	"./theme_gold/images/sup/payment_mb_02.png": "bb0f",
	"./theme_gold/images/sup/payment_mb_03.png": "daa3",
	"./theme_gold/images/sup/payment_mb_04.png": "aba6",
	"./theme_gold/images/sup/payment_mb_05.png": "e6e3",
	"./theme_gold/images/sup/payment_mb_06.png": "1d65",
	"./theme_gold/images/sup/payment_mb_07.png": "cb86",
	"./theme_gold/images/sup/payment_mb_08.png": "2e45",
	"./theme_gold/images/sup/payment_mb_09.png": "7d2b",
	"./theme_gold/images/sup/payment_mb_10.png": "c004",
	"./theme_gold/images/sup/payment_mb_11.png": "ce16",
	"./theme_gold/images/sup/payment_pc_01.png": "905c",
	"./theme_gold/images/sup/payment_pc_02.png": "a1ed",
	"./theme_gold/images/sup/payment_pc_03.png": "ed03",
	"./theme_gold/images/sup/payment_pc_04.png": "eef8",
	"./theme_gold/images/sup/payment_pc_05.png": "f8e3",
	"./theme_gold/images/sup/payment_pc_06.png": "fd8a",
	"./theme_gold/images/sup/payment_pc_07.png": "551e",
	"./theme_gold/images/sup/payment_pc_08.png": "4cb7",
	"./theme_gold/images/sup/payment_pc_09.png": "2ca3",
	"./theme_gold/images/sup/payment_pc_10.png": "774d",
	"./theme_gold/images/sup/payment_pc_11.png": "a772",
	"./theme_gold/images/sup/payment_pc_12.png": "bdd6",
	"./theme_gold/images/sup/pc_banner_sup_acc.webp": "62b4",
	"./theme_gold/images/sup/pc_banner_sup_accout.webp": "4dba",
	"./theme_gold/images/sup/pc_banner_sup_coupon.webp": "df20",
	"./theme_gold/images/sup/pc_banner_sup_event.webp": "b795",
	"./theme_gold/images/sup/pc_banner_sup_faq.webp": "246c",
	"./theme_gold/images/sup/pc_banner_sup_faq_k.webp": "5a98",
	"./theme_gold/images/sup/pc_banner_sup_login.webp": "874c",
	"./theme_gold/images/sup/pc_banner_sup_pay.webp": "ec76",
	"./theme_gold/images/sup/pc_banner_sup_recommend.webp": "5c10",
	"./theme_gold/images/sup/pc_banner_sup_responsible.webp": "e5e1",
	"./theme_gold/images/sup/pc_banner_sup_shop.webp": "edef",
	"./theme_gold/images/sup/pc_banner_sup_vip.webp": "3da7",
	"./theme_gold/images/sup/pc_banner_sup_wallet.webp": "63e5",
	"./theme_gold/images/sup/recommended_01.webp": "a090",
	"./theme_gold/images/sup/recommended_02.webp": "1a82",
	"./theme_gold/images/sup/recommended_03.webp": "ac68",
	"./theme_gold/images/sup/recommended_04.webp": "73af",
	"./theme_gold/images/sup/recommended_05.webp": "2552",
	"./theme_gold/images/sup/register_mb_01.png": "1e3e",
	"./theme_gold/images/sup/register_mb_02.png": "f5d5",
	"./theme_gold/images/sup/register_mb_03.png": "7321",
	"./theme_gold/images/sup/register_mb_04.png": "3965",
	"./theme_gold/images/sup/register_mb_05.png": "7f1a",
	"./theme_gold/images/sup/register_pc_01.png": "95c8",
	"./theme_gold/images/sup/register_pc_02.png": "724b",
	"./theme_gold/images/sup/register_pc_03.png": "4996",
	"./theme_gold/images/sup/register_pc_04.png": "cf85",
	"./theme_gold/images/sup/register_pc_05.png": "6ead",
	"./theme_gold/images/sup/shop_mb_tab_01.png": "0aca",
	"./theme_gold/images/sup/shop_mb_tab_02.png": "6ab9",
	"./theme_gold/images/sup/shop_pc_tab_01.png": "96e2",
	"./theme_gold/images/sup/shop_pc_tab_02.png": "3afa",
	"./theme_gold/images/sup/table.png": "112d",
	"./theme_gold/images/sup/vip_mb_tab_01.png": "fbd7",
	"./theme_gold/images/sup/vip_mb_tab_02.png": "5e2d",
	"./theme_gold/images/sup/vip_mb_tab_03.png": "8c80",
	"./theme_gold/images/sup/vip_pc_tab_01.png": "4f7b",
	"./theme_gold/images/sup/vip_pc_tab_02.png": "b8ee",
	"./theme_gold/images/sup/wallet_mb_01.png": "f2cf",
	"./theme_gold/images/sup/wallet_mb_02.png": "e2f4",
	"./theme_gold/images/sup/wallet_mb_03.png": "1c8c",
	"./theme_gold/images/sup/wallet_mb_04.png": "9b3b",
	"./theme_gold/images/sup/wallet_mb_05.png": "ed58",
	"./theme_gold/images/sup/wallet_mb_06.png": "60b2",
	"./theme_gold/images/sup/wallet_pc_01.png": "ad88",
	"./theme_gold/images/sup/wallet_pc_02.png": "a184",
	"./theme_gold/images/sup/wallet_pc_03.png": "1320",
	"./theme_gold/images/sup/wallet_pc_04.png": "2d6a",
	"./theme_gold/images/sup/wallet_pc_05.png": "2b1c",
	"./theme_gold/images/sup/wallet_pc_06.png": "91fc",
	"./theme_gold/images/sup/wallet_pc_07.png": "56f7",
	"./theme_gold/images/sup/wallet_pc_08.png": "dbae",
	"./theme_gold/images/terms-bg.png": "fa81",
	"./theme_gold/images/title-championship.png": "579d",
	"./theme_gold/images/top10-bn.png": "c73d",
	"./theme_gold/images/top10-bn2.png": "273b",
	"./theme_gold/images/top_up.png": "20d1",
	"./theme_gold/images/trophy-gold.svg": "6d69",
	"./theme_gold/images/trophy-icon.svg": "257d",
	"./theme_gold/images/useful_link/agent_five.webp": "06a1",
	"./theme_gold/images/useful_link/agent_four.webp": "60b9",
	"./theme_gold/images/useful_link/agent_one.webp": "5fcc",
	"./theme_gold/images/useful_link/agent_three.webp": "b6ed",
	"./theme_gold/images/useful_link/agent_two.webp": "7dd3",
	"./theme_gold/images/useful_link/agent_validSeal.webp": "7f9e",
	"./theme_gold/images/useful_link/bg.jpg": "0a16",
	"./theme_gold/images/useful_link/bonusIntroducing.webp": "48b3",
	"./theme_gold/images/useful_link/how_to_join_1.webp": "190a",
	"./theme_gold/images/useful_link/how_to_join_2.webp": "3180",
	"./theme_gold/images/useful_link/how_to_join_3.webp": "59ec",
	"./theme_gold/images/useful_link/icon_FAQ.png": "7cef",
	"./theme_gold/images/useful_link/icon_account_binding.png": "679f",
	"./theme_gold/images/useful_link/icon_confirm_method.png": "bfc0",
	"./theme_gold/images/useful_link/icon_coupon.png": "8f9f",
	"./theme_gold/images/useful_link/icon_deposit_withdraw.png": "6942",
	"./theme_gold/images/useful_link/icon_event_bonus.png": "9679",
	"./theme_gold/images/useful_link/icon_login.png": "5314",
	"./theme_gold/images/useful_link/icon_login_method.png": "b8c0",
	"./theme_gold/images/useful_link/icon_recommended_games.png": "8068",
	"./theme_gold/images/useful_link/icon_self_restriction.png": "cd56",
	"./theme_gold/images/useful_link/icon_shop.png": "089f",
	"./theme_gold/images/useful_link/icon_vip_class_upgrading.png": "13d8",
	"./theme_gold/images/useful_link/icon_wallet.png": "50f2",
	"./theme_gold/images/useful_link/pc_banner_agent.jpeg": "b993",
	"./theme_gold/images/useful_link/pc_banner_cookie.jpeg": "e535",
	"./theme_gold/images/useful_link/pc_banner_cooperation.jpeg": "e93e",
	"./theme_gold/images/useful_link/pc_banner_cooperation.jpg": "7647",
	"./theme_gold/images/useful_link/pc_banner_privacy.jpeg": "b597",
	"./theme_gold/images/useful_link/pc_banner_rule.jpeg": "0a61",
	"./theme_gold/images/useful_link/pc_banner_support.jpeg": "7cdc",
	"./theme_gold/images/useful_link/pc_banner_support.png": "2c56",
	"./theme_gold/images/useful_link/pc_banner_terms.jpeg": "96d8",
	"./theme_gold/images/useful_link/permanentIncome.webp": "bf25",
	"./theme_gold/images/vector.svg": "e980",
	"./theme_gold/images/verify.png": "8b0d",
	"./theme_gold/images/vip-24-hours.png": "2c23",
	"./theme_gold/images/vip-arrow-left.png": "48da",
	"./theme_gold/images/vip-arrow-right.png": "275d",
	"./theme_gold/images/vip-bg.jpg": "9c2b",
	"./theme_gold/images/vip-coin-stack.png": "3313",
	"./theme_gold/images/vip-crown.png": "265a",
	"./theme_gold/images/vip-green-line.png": "c6ff",
	"./theme_gold/images/vip-roulette.png": "3807",
	"./theme_gold/images/vip-wallet.png": "9cc2",
	"./theme_gold/images/vip.png": "ab9f",
	"./theme_gold/images/vip_bg.jpg": "f21c",
	"./theme_gold/images/vip_bg.png": "29c8",
	"./theme_gold/images/vip_gift_bg.png": "5e7b",
	"./theme_gold/images/wallet.png": "480d",
	"./theme_gold/images/web_TOP.png": "7399",
	"./theme_gold/images/wheel_2x.png": "598a",
	"./theme_gold/minor_css/proxy/bootstrap.min.css": "0307",
	"./theme_gold/minor_css/proxy/bootstrap.min.css.map": "b6d2",
	"./theme_gold/minor_css/proxy/proxy_style.css": "b043"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";